// Ideallly this is the only service that imports and handles all "data chip" related services
// this is in order to prevent from these services to explode and receive unrelated functionality
const { htmlToText } = require('html-to-text');

import ParsingService from './parsing-service';
import DataChipService from './DataChip/data-chip-service';
import FormulasService from './FormulaChip/formulas-service';
import HtmlDocumentService from '@/components/common/RichTextBox/HtmlAttributes/html-document-service.js';
import FormatConversionService from './format-conversion-service';

import { TEXT_BOX_FORMAT_TYPES } from './rich-text-box.const';
// import { INSERT_DATA_DELIMITER_PREFIX, INSERT_DATA_DELIMITER_SUFFIX } from './DataChip/data-chip.const';
import { FORMULAS_DELIMITER_PREFIX, FORMULAS_DELIMITER_SUFFIX } from './FormulaChip/formulas.const';

/* Private */
const htmlToTextConf = { preserveNewlines: true, wordwrap: false, trimEmptyLines: false, whitespaceCharacters: '' };

const isPlainText = (format) => ![TEXT_BOX_FORMAT_TYPES.MARKDOWN, TEXT_BOX_FORMAT_TYPES.HTML].includes(format);

// const escapeHTML = (str) =>
// 	(str + '').replace(/[&<>"']/g, (s) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s]));

function documentStringToTiptapHtml(docStr, newContentFormatType) {
	let tiptapHtml = docStr;
	if (isPlainText(newContentFormatType)) {
		tiptapHtml = FormatConversionService.convertTextToHtmlForTiptapPresentation(tiptapHtml);
	}
	// if (newContentFormatType === TEXT_BOX_FORMAT_TYPES.MARKDOWN) {
	// 	tiptapHtml = FormatConversionService.convertMarkdownToHtmlForTiptapPresentation(tiptapHtml);
	// }
	// console.log('--------->>> documentStringToTiptapHtml docStr:', docStr);
	// console.log('--------->> documentStringToTiptapHtml tiptapHtml:', tiptapHtml);
	return tiptapHtml;
}

function tiptapHtmlToDocumentString(tiptapHtml, richTextFieldFormat) {
	let docStr = tiptapHtml;
	if (isPlainText(richTextFieldFormat)) {
		docStr = ParsingService.replaceParagraphsWithLineBreaks(docStr, '\n');
	}
	// if (richTextFieldFormat === TEXT_BOX_FORMAT_TYPES.MARKDOWN) {
	// 	docStr = FormatConversionService.convertHtmlToMarkdownForTiptapPresentation(docStr);
	// }
	docStr = isPlainText(richTextFieldFormat) ? htmlToText(docStr, htmlToTextConf) : docStr;
	// console.log('<<<--------- tiptapHtmlToDocumentString tiptapHtml:', tiptapHtml);
	// console.log('<<<--------- tiptapHtmlToDocumentString docStr:', docStr);

	return docStr;
}

export const privateForTests = {
	documentStringToTiptapHtml,
	tiptapHtmlToDocumentString,
};

/* Public */

function isRichText(format) {
	return [TEXT_BOX_FORMAT_TYPES.HTML, TEXT_BOX_FORMAT_TYPES.MARKDOWN].includes(format);
}

function getOrderedDataInputs() {
	// order matters (!)
	return [FormulasService, DataChipService];
}

function toTiptapPreprocessing(documentString, htmlWithBracesFormatType, previousStepsData, replaceInsertDataStringDict) {
	let response = documentString;
	// const isHtml = TEXT_BOX_FORMAT_TYPES.HTML === htmlWithBracesFormatType;

	if (!isRichText(htmlWithBracesFormatType)) {
		// Guy:
		// Remove this one as it encodes to &quot; and breaks stuff.
		// response = escapeHTML(documentString);
		/* Also removed this as we dont need to change to &nbsp; when we let tiptap handle it. */
		// 	response = ParsingService.mapUnlessDelimittedContent(INSERT_DATA_DELIMITER_PREFIX, INSERT_DATA_DELIMITER_SUFFIX, response, (str) =>
		// 		str.replaceAll(' ', '&nbsp;')
		// 	);
	}

	response = FormulasService.reformatParagraphAccordingToFormula(response);
	if (isRichText(htmlWithBracesFormatType)) {
		response = HtmlDocumentService.toTipTapHtmlAttributes(response, previousStepsData, replaceInsertDataStringDict);
	}

	return response;
}

function toTiptapPostprocessing(newContent, richTextFieldFormat) {
	return documentStringToTiptapHtml(newContent, richTextFieldFormat);
}

function fromTiptapPreprocessing(documentString) {
	return documentString;
}

function fromTiptapPostprocessing(documentString, htmlWithBracesFormatType) {
	let result = documentString;
	result = ParsingService.tokenizeAndRun(FORMULAS_DELIMITER_PREFIX, FORMULAS_DELIMITER_SUFFIX, result, (str) =>
		tiptapHtmlToDocumentString(str, htmlWithBracesFormatType)
	);
	if (isRichText(htmlWithBracesFormatType)) {
		result = HtmlDocumentService.fromTipTapHtmlAttributes(result);
	}
	return result;
}

const RichTextDataInputsService = {
	getOrderedDataInputs,
	toTiptapPreprocessing,
	toTiptapPostprocessing,
	fromTiptapPreprocessing,
	fromTiptapPostprocessing,
	isRichText,
};

export default RichTextDataInputsService;
